import { motion, AnimatePresence } from "framer-motion";
import { LOGOS } from "@/data/site";

export const Loader = ({ show }) => {
  return (
    <AnimatePresence>
      {show && (
        <motion.div
          key="loader"
          data-testid="page-loader"
          className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-[#050505]"
          exit={{ opacity: 0, transition: { duration: 0.6, ease: "easeInOut" } }}
        >
          <div className="grain-overlay" />
          <motion.div
            initial={{ scale: 0.7, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
            className="relative"
          >
            <motion.img
              src={LOGOS.icon}
              alt="Karting Bahamas"
              className="w-28 md:w-36 select-none"
              animate={{ y: [0, -10, 0] }}
              transition={{ repeat: Infinity, duration: 1.4, ease: "easeInOut" }}
            />
          </motion.div>
          <div className="mt-10 h-[3px] w-48 overflow-hidden rounded-full bg-white/10">
            <motion.div
              className="h-full speed-streak"
              initial={{ x: "-100%" }}
              animate={{ x: "100%" }}
              transition={{ repeat: Infinity, duration: 1.1, ease: "easeInOut" }}
            />
          </div>
          <motion.p
            className="mt-6 font-display text-lg tracking-[0.4em] text-white/50"
            animate={{ opacity: [0.3, 1, 0.3] }}
            transition={{ repeat: Infinity, duration: 1.6 }}
          >
            LIGHTS OUT
          </motion.p>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Loader;
